import Paso from '../Paso';
import cn from 'classnames';

const PestanaForm = ({ text, number, bgColor, step, checkStep, form = 'quiero-ser' }) => {
  return (
    <div className="relative w-fit mr-40 sm:mr-60">
      <div className="mb-13">
        <p
          className={cn('p1 text-black opacity-40 duration-30 whitespace-nowrap', {
            '!opacity-100': step
          })}
        >
          {text}
        </p>
      </div>
      <div className="relative w-52 h-52">
        <div
          className={cn(
            'absolute z-1 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 scale-0 duration-40',
            {
              'scale-100': step
            }
          )}
        >
          <Paso number={number} bgColor={bgColor} />
        </div>
        <div
          className={cn(
            'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-8 h-8 rounded-full',
            bgColor
          )}
        ></div>
        <div
          className={cn(
            'absolute z-1 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 scale-0 duration-40',
            {
              'scale-100': checkStep
            }
          )}
        >
          <div
            className={cn('relative w-32 h-32 rounded-full', {
              'bg-gradient-check-quiero': form === 'quiero-ser',
              'bg-gradient-check-empresas': form === 'empresas'
            })}
          >
            <svg
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
              width="12"
              height="8"
              viewBox="0 0 12 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 4.19988L4.18191 7L11 1" stroke="#FEFEFE" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PestanaForm;
